<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="store-listing"
    [viewName]="title"
    [record]="StoreListingRecord"
    [fields]="fields"
    [nestedPopulate]="true"
>
</dynamic-view-v2>
